export default "__VITE_ASSET__8b2947d9__"